<div class="app-switch" *ngIf="this.enableKanban">
  <p class="board-switch">
    Kanban View
    <nz-switch [(ngModel)]="switchValue"> </nz-switch>
  </p>
</div>

<ng-container *ngIf="!isLoading">
  <app-records-list
    *ngIf="!switchValue && moduleId != undefined"
    [moduleId]="moduleId"
    (selectionChanged)="selectionChanged.emit($event)"
    [isKanban]="false"
  ></app-records-list>

  <div
    style="margin-top: 5px"
    class="root"
    *ngIf="
      switchValue &&
      moduleInformation !== undefined &&
      moduleStructure !== undefined
    "
  >
    <div class="board">
      <div class="board-bar">
        <p class="board-name">{{ board.name }}</p>
      </div>

      <div class="board-wrapper">
        <div class="board-columns" cdkDropListGroup>
          <div class="board-column" *ngFor="let column of board.columns">
            <span
              class="taskListDrag boards-column--header--color"
              data-bind="style: { 'background-color': boardColumn.color }"
            ></span>
            <div class="column-title">
              {{ column.Name }}
            </div>
            <!-- <div style="overflow: auto;" [style.height]="(this.screenHeight - 450) + 'px'"> -->
            <app-records-list
              [moduleInformation]="moduleInformation"
              [moduleStructure]="moduleStructure"
              (selectionChanged)="selectionChanged.emit($event)"
              [filters]="{
                StepLast: { singleValue: column.Name, filterType: 3 }
              }"
              [moduleId]="moduleId"
              [isKanban]="true"
            ></app-records-list>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
